import CareersDropdown from 'src/components/Dropdown/CareersDropdown'
import GenericItemCard from 'src/components/Cards/GenericItemCard'
import { CLOSED_STATUS } from '../../constants'
import { TagVariant } from 'src/components/ColoredTag/styles'
import { getTagVariantByRegime } from '../../utils'

const CareerListItem: React.FC<any> = ({
  id,
  title,
  regime,
  status,
  post,
  canEdit,
  canDelete
}) => {
  const hasPermission = canEdit || canDelete
  const tags: { label: string; variant: TagVariant }[] = [
    {
      label: regime,
      variant: getTagVariantByRegime(regime)
    }
  ]
  if (status === CLOSED_STATUS) {
    tags.push({ label: 'ENCERRADA', variant: 'gray' })
  }

  const dropdownElement = (
    <CareersDropdown
      id={id}
      post={post}
      canEdit={canEdit}
      canDelete={canDelete}
    />
  )

  return (
    <GenericItemCard
      title={title}
      tags={tags}
      url={'/news/careers/' + id}
      linkMode={hasPermission ? 'showMore' : 'wholeCard'}
      menu={hasPermission ? dropdownElement : undefined}
    />
  )
}

export default CareerListItem
